export enum MaatAuditPlanType {
  Quality = 'quality',
  Random = 'random'
}